//src/components/ZaraChatWidget.js

import React from "react";
import AIZzra from "../assets/AI.png";

const FloatingZaraButton = ({ onClick, isEn = true }) => {
  return (
    <button
      onClick={onClick}
      aria-label={isEn ? "Chat with ZARA" : "ZARA se chat karein"}
      style={{
        position: "fixed",
        right: "20px",
        bottom: "20px",
        zIndex: 9990,
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        border: "none",
        background: "linear-gradient(135deg, #00B7E8 0%, #0077a3 100%)",
        boxShadow: "0 8px 24px rgba(0, 119, 163, 0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: 0,
      }}
    >
      <img
        src={AIZzra}
        alt=""
        style={{ width: "38px", height: "38px", objectFit: "contain", background: "white", borderRadius: "50%", padding: "3px" }}
      />
      <span style={{ position: "absolute", top: "4px", right: "4px", width: "12px", height: "12px", background: "#2ecc71", borderRadius: "50%", border: "2px solid white" }} />
    </button>
  );
};

export default FloatingZaraButton;